import { SyncType } from 'stores/parsers/types';

export const syncTypeOptions: SyncType[] = ['newspapers', 'points', 'products'];
